import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
} from "@material-ui/core";
//components
import BeaconForm from "./BeaconForm";
import BuoyForm from "./BuoyForm";
import LighthouseForm from "./LighthouseForm";

//styles
import useStyle from "./styles";

function SignTypes(props) {
  const classes = useStyle();

  const [signType, setSignType] = useState("buoy");
  const [data, setData] = useState({});
  const saveHandle = () => {
    let layer = props.layer;
    console.log(data);
    if (Object.keys(data).length === 0 && data.constructor === Object) {
      layer.bindPopup("No Information");
      layer.openPopup();
    } else {
      let popupContent = `<table style={width : 150}><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody>`;
      for (const [key, value] of Object.entries(data)) {
        popupContent += `<tr><td>${key}</td><td> ${value}</td></tr>`;
      }
      popupContent += "</tbody></table>";
      layer.bindPopup(popupContent);
      layer.openPopup();
    }
    props.setShowModal(false);
  };

  return (
    <Grid container direction="row" spacing={1}>
      <Grid item container justify="center" alignItems="center" md={3}>
        <Grid item>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel htmlFor="type-of-sign-select">Type</InputLabel>
            <Select
              native
              value={signType}
              onChange={(e) => {
                setSignType(e.target.value);
              }}
              label="Type"
              inputProps={{
                name: "Type",
                id: "type-of-sign-select",
              }}
            >
              <option value={"buoy"}>Buoy</option>
              <option value={"lighthouse"}>Lighthouse</option>
              <option value={"beacon"}>Beacon</option>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid item container justify="center" alignItems="center" md={7}>
        {signType === "buoy" ? (
          <BuoyForm setData={setData} />
        ) : signType === "lighthouse" ? (
          <LighthouseForm setData={setData} />
        ) : (
          <BeaconForm setData={setData} />
        )}
      </Grid>
      <Grid item container justify="center" alignItems="center" md={2}>
        <Button variant="outlined" color="primary" onClick={saveHandle}>
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default SignTypes;
